export default __webpack_public_path__ + "static/media/new-reddit-dark.bc62cc34.svg";